import { memo } from 'react'
import type { Card } from '../../types'
import { motion } from 'framer-motion'
import { getCardPadding, getScaledFontSize } from '../../utils/gridLayout'

interface TextCardProps {
  card: Card
  editMode: boolean
  cellSize: number
}

const TextCard = memo(function TextCard({ card, editMode, cellSize }: TextCardProps) {
  const { text, textFontSize = 'small', textAlign = 'left', textVAlign = 'top', textTransparent = false } = card.content

  const padding = Math.round(getCardPadding(cellSize))
  const fontSizeMap = {
    small: getScaledFontSize(cellSize, 14),
    medium: getScaledFontSize(cellSize, 18),
    large: getScaledFontSize(cellSize, 23)
  }
  const fontSize = fontSizeMap[textFontSize]
  const alignClass = textAlign === 'center' ? 'text-center' : textAlign === 'right' ? 'text-right' : 'text-left'
  const vAlignClass = textVAlign === 'center' ? 'justify-center' : 'justify-start'

  const renderEmphasis = (input: string) => {
    const parts = input.split(/(\*[^*]+\*)/g)
    return parts.map((part, i) => {
      if (part.startsWith('*') && part.endsWith('*') && part.length >= 3) {
        return (
          <span key={i} className="font-semibold">
            {part.slice(1, -1)}
          </span>
        )
      }
      return <span key={i}>{part}</span>
    })
  }

  return (
    <motion.div
      className={`w-full h-full overflow-hidden ${textTransparent
        ? `relative ${editMode ? 'border border-dashed border-white/30' : ''}`
        : 'theme-card'
        }`}
      style={textTransparent ? { borderRadius: 'var(--card-radius, 16px)' } : undefined}
    >
      <div
        className={`w-full h-full overflow-auto no-scrollbar flex flex-col ${vAlignClass}`}
        style={{ padding: `${padding}px` }}
      >
        <p
          className={`font-serif ${alignClass} leading-relaxed whitespace-pre-wrap break-words ${textTransparent ? 'mix-blend-difference text-white' : ''
            }`}
          style={{ fontSize: `${fontSize}px` }}
        >
          {renderEmphasis(text || 'Try: *bold text*')}
        </p>
      </div>
    </motion.div>
  )
})

export default TextCard
